import { apiUrl } from "./config.json";
import httpService from "./httpService";
let apiEndpoint = "";
if (process.env.NODE_ENV !== "production") {
  apiEndpoint = apiUrl + "/naics";
} else {
    apiEndpoint = apiUrl + "/naics";
}
   
 
  export async function getnaics(){
    const response=await httpService.get(`${apiEndpoint}/getnaics`);
    return response;
  }


   
  export default {
   
    getnaics
   
  }